export default "__VITE_ASSET__BrV3R7WD__"